import "./Attendance.css";
import * as React from "react";
import { useLocation } from "react-router-dom"; // Import the hook

import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";

import Typography from "@mui/material/Typography";
import Header from "../Includes/Header";
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import PropTypes from "prop-types";

import AttendanceEmp from "./AttendanceEmp";
import AttendanceMember from "./AttendanceMember";
import AttendanceNonRegister from "./AttendanceNonRegister";

import { useNavigate } from "react-router-dom";

const drawerWidth = 292;
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

function Attendance() {
  const { colors: appColors } = useAppTheme();
  const navigate = useNavigate();
  const location = useLocation(); // Access location
  const [value, setValue] = React.useState(0);
  const [memberTotal, setMemberTotal] = React.useState(0);
  const [empTotal, setEmpTotal] = React.useState(0);
  const [nonRegisterTotal, setNonRegisterTotal] = React.useState(0);
  const [localrole] = React.useState(() => {
    try {
      return JSON.parse(localStorage.getItem("userdata"))?.role || "";
    } catch {
      return "";
    }
  });
  React.useEffect(() => {
    // If tabIndex is passed in the location state, set it to the tab value
    if (location.state?.tabIndex !== undefined) {
      if (location.state.tabIndex === 1 && localrole !== 'admin') return;
      setValue(location.state.tabIndex);
    }
  }, [location.state, localrole]);
  const handleChangetab = (event, newValue) => {
    setValue(newValue);
  };

  const drawer = (
    <div className="d-flex flex-column h-100">
      <Header />
    </div>
  );
  React.useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      // User is not logged in, no need to redirect
      navigate('/');
    }
    
  }, []);
  const tabStyle = (isActive) => ({
    textDecoration: "none",
    flexGrow: 1,
    textTransform: "none",
    fontWeight: "bold",
    marginRight: "10px",
    backgroundColor: isActive ? appColors.leafSoft : "inherit",
    borderRadius: "10px 10px 0px 0px",
    borderBottom: isActive ? `2px solid ${appColors.leaf}` : "none",
    color: isActive ? appColors.leaf : "inherit",
  });
  return (
    <Box sx={{ display: "flex", height: "100vh", backgroundColor: "#EFEDF1" }}>
      <CssBaseline />
      <Box>
        <Header />
      </Box>

      <Box
        component="main"
        sx={{ flexGrow: 1, minWidth: 0, overflowY: "auto", overflowX: "hidden",  }}
      >
        <div style={{ display: "flex", flexGrow: 1, marginTop: "64px" }}>
          <div style={{ flex: 1, marginTop: "10px" }}>
            <Box sx={{ flexGrow: 1 }}>
              <Box
                sx={{
                  borderBottom: 1,
                  marginLeft: "25px",
                  borderColor: "divider",
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChangetab}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="scrollable auto tabs example"
                >
                  <Tab
                    sx={{
                      ...tabStyle(0 === value),
                    }}
                    label={`Members (${memberTotal})`}
                    {...a11yProps(0)}
                  />
                  {localrole === 'admin' && (
                  <Tab
                    sx={{
                      ...tabStyle(1 === value),
                    }}
                    label={`Employees (${empTotal})`}
                    {...a11yProps(1)}
                  />
                  )}
                  {localrole === 'admin' && (
                  <Tab
                    sx={{
                      ...tabStyle(2 === value),
                    }}
                    label={`Non-Register (${nonRegisterTotal})`}
                    {...a11yProps(2)}
                  />
                  )}
                </Tabs>
              </Box>
            </Box>

            <TabPanel value={value} index={0}>
              <AttendanceMember onTotalChange={(n) => setMemberTotal(n)} />
            </TabPanel>

            {localrole === 'admin' && (
            <TabPanel value={value} index={1}>
              <AttendanceEmp onTotalChange={(n) => setEmpTotal(n)} />
            </TabPanel>
            )}

            {localrole === 'admin' && (
            <TabPanel value={value} index={2}>
              <AttendanceNonRegister onTotalChange={(n) => setNonRegisterTotal(n)} />
            </TabPanel>
            )}
          </div>
        </div>
      </Box>
    </Box>
  );
}

export default Attendance;
